import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { rupee } from "./format";

const Nums = ({ d, showSanc, bold }) => (
  <>
    {showSanc && <td className="px-3 py-1.5 text-right font-mono">{rupee(d.sanctioned)}</td>}
    <td className="px-3 py-1.5 text-right font-mono">{rupee(d.working)}</td>
    <td className="px-3 py-1.5 text-right font-mono">{rupee(d.spent_period)}</td>
    <td className="px-3 py-1.5 text-right font-mono">{rupee(d.spent_cum)}</td>
    <td className="px-3 py-1.5 text-right font-mono text-amber-700" data-testid="summary-committed">{rupee(d.committed || 0)}</td>
    <td className="px-3 py-1.5 text-right font-mono">{rupee(d.balance)}</td>
    <td className={`px-3 py-1.5 text-right font-mono ${d.util > 90 ? "text-rose-600" : "text-slate-600"} ${bold ? "font-bold" : ""}`}>{d.util}%</td>
  </>
);

export const SummaryTable = ({ data, showSanc, onOpenSub }) => {
  const span = showSanc ? 8 : 7;
  return (
    <Card>
      <CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm" data-testid="report-summary-table">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500">
            <tr className="border-b">
              <th className="text-left px-3 py-2">Line</th>
              {showSanc && <th className="text-right px-3 py-2">Sanctioned</th>}
              <th className="text-right px-3 py-2">Working</th>
              <th className="text-right px-3 py-2">Spent – selected period</th>
              <th className="text-right px-3 py-2">Spent – cumulative</th>
              <th className="text-right px-3 py-2">Committed (open advances)</th>
              <th className="text-right px-3 py-2">Balance</th>
              <th className="text-right px-3 py-2">% Util</th>
            </tr>
          </thead>
          <tbody>
            {data.categories.map(c => (
              <React.Fragment key={c.code}>
                <tr className="bg-slate-100 font-semibold text-xs uppercase" data-testid={`summary-cat-${c.code}`}>
                  <td className="px-3 py-1.5">{c.code} · {c.name}</td><Nums d={c.totals} showSanc={showSanc} />
                </tr>
                {c.heads.map(h => (
                  <React.Fragment key={h.id}>
                    <tr className="bg-slate-50 border-b font-medium">
                      <td className="px-3 py-2 pl-6">{h.code} · {h.name}</td><Nums d={h.totals} showSanc={showSanc} />
                    </tr>
                    {h.subtypes.map(s => (
                      <tr key={s.id} className="border-b hover:bg-amber-50 cursor-pointer" onClick={() => onOpenSub(s)} data-testid={`subtype-row-${s.code}`}>
                        <td className="px-3 py-1.5 pl-12 text-xs">
                          <span className="font-mono">{s.code}</span> · {s.name}
                          {s.status === "disabled" && <Badge variant="outline" className="ml-2 text-[10px]">disabled</Badge>}
                        </td>
                        <Nums d={s} showSanc={showSanc} />
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </React.Fragment>
            ))}
            {!data.categories.length && <tr><td colSpan={span} className="text-center text-sm text-slate-500 py-6">No lines to show.</td></tr>}
            <tr className="border-t-2 border-slate-400 bg-slate-100 font-bold" data-testid="summary-grand-total">
              <td className="px-3 py-2">Grand Total</td><Nums d={data.grand} showSanc={showSanc} bold />
            </tr>
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
};
